function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Commnt from '@/components/develop/commonData';
import oaDialog from '@/components/form-common/dialog-form';
import { getDictListApi } from '@/api/form';
import { dataFieldTypeApi, dataFieldListApi, dataFieldSaveApi, dataFieldDeleteApi, dataFieldInfoApi, dataFieldUpdateApi, dataFieldMainApi } from '@/api/develop';
export default {
  name: '',
  components: {
    oaDialog: oaDialog
  },
  props: {
    infoData: {
      type: Object,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      search: '',
      loading: false,
      total: 0,
      where: {
        name: ''
      },
      info: this.infoData,
      fromData: {
        width: '600px',
        title: '新建字段',
        btnText: '确定',
        labelWidth: '100px',
        type: ''
      },
      type: 'add',
      rowData: {},
      rowId: 0,
      formConfig: [],
      formRules: Commnt.fieldRules,
      formDataInit: Commnt.fieldDataInit,
      typesList: [],
      // 字段数据
      tableData: [],
      // 表格数据
      dictList: [],
      // 字典数据
      valueItem: ['crud_id', 'value', 'field_name', 'field_name_en', 'is_uniqid', 'is_default_value_not_null',
      // 允许空值
      'is_table_show_row',
      // 列表默认显示
      'create_modify',
      // 新增时修改
      'update_modify',
      // 更新时修改
      'comment', 'data_dict_id', 'association_crud_id', 'association_field_names', 'association_field_names_list']
    };
  },
  mounted: function mounted() {
    this.getTypeList();
    this.getList();
  },
  computed: {
    searchList: function searchList() {
      var _this = this;
      var list = [{
        options: []
      }];
      if (this.search !== '') {
        this.typesList.map(function (item) {
          item.options.map(function (key) {
            if (key.label.includes(_this.search)) {
              list[0].options.push(key);
            }
          });
        });
      } else {
        list = this.typesList;
      }
      return list;
    }
  },
  methods: {
    // 获取字典列表
    getDictList: function getDictList() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var data, result;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              data = {
                page: 1,
                limit: '',
                form_value: _this2.rowData.value
              };
              _context.next = 3;
              return getDictListApi(data);
            case 3:
              result = _context.sent;
              if (result.data.list.length > 0) {
                _this2.dictList = result.data.list.filter(function (item) {
                  return item.status == 1;
                });
              }
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    // 数组转成字符串
    getValue: function getValue(val) {
      var str = '';
      if (val == '') {
        str = '--';
      } else if (Array.isArray(val)) {
        str = val.toString();
      } else {
        str = val;
      }
      return str || '--';
    },
    // 获取全部字段类型
    getTypeList: function getTypeList() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var data;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return dataFieldTypeApi();
            case 2:
              data = _context2.sent;
              _this3.typesList = data.data;
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    // 获取字段列表
    getList: function getList() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var data;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this4.loading = true;
              _context3.next = 3;
              return dataFieldListApi(_this4.info.id, _this4.where);
            case 3:
              data = _context3.sent;
              _this4.tableData = data.data;
              _this4.loading = false;
            case 6:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    // 获取字段详情
    editFn: function editFn(row) {
      var _this5 = this;
      this.rowId = row.id;
      this.type = 'edit';
      if (['radio', 'cascader_radio', 'checkbox', 'cascader', 'tag'].includes(row.form_value)) {
        this.getDictList();
      }
      // 编辑回显数据
      dataFieldInfoApi(row.id).then(function (res) {
        var obj = res.data.options;
        for (var key in res.data) {
          if (_this5.valueItem.includes(key)) {
            _this5.formDataInit[key] = res.data[key];
          }
        }
        _this5.formDataInit.value = res.data.form_value;
        _this5.formDataInit = _objectSpread(_objectSpread({}, _this5.formDataInit), obj);
        _this5.fromData.title = "\u7F16\u8F91\u5B57\u6BB5";
        _this5.fromData.type = 'edit';
        var dynamicList = Commnt.keyValue[res.data.form_value];
        if (dynamicList) {
          dynamicList.forEach(function (item) {
            if (item.sign == 'dict') {
              item.options = _this5.dictList;
            }
          });
        } else {
          dynamicList = [];
        }
        _this5.formConfig = [];
        // 深拷贝是为了不修改原数组
        var config = JSON.parse(JSON.stringify(Commnt.fieldConfig));
        config.splice.apply(config, [2, 0].concat(_toConsumableArray(dynamicList)));
        _this5.formConfig = config;
        _this5.$refs.oaDialog.openBox();
      });
    },
    // 删除字段
    deleteFn: function deleteFn(row) {
      var _this6 = this;
      this.$modalSure('您确定要删除此字段数据吗').then(function () {
        dataFieldDeleteApi(row.id).then(function (res) {
          _this6.getList();
        });
      });
    },
    // 开启主展示字段
    handleMain: function handleMain(row) {
      var _this7 = this;
      if (row.is_main == 1) {
        dataFieldMainApi(row.id).then(function (res) {
          _this7.getList();
        });
      }
    },
    // 新建字段弹窗
    handleClick: function handleClick(val) {
      var _this8 = this;
      this.type = 'add';
      this.rowData = val;
      if (val.value == 'tag') {
        this.formRules.data_dict_id[0].required = false;
      } else {
        this.formRules.data_dict_id[0].required = true;
      }
      if (['radio', 'cascader_radio', 'checkbox', 'cascader', 'tag'].includes(val.value)) {
        this.getDictList();
      }
      this.formDataInit = {
        crud_id: 0,
        value: '',
        field_name: '',
        field_name_en: '',
        is_default_value_not_null: 1,
        // 允许空值
        is_table_show_row: 1,
        // 列表默认显示
        create_modify: 1,
        // 新增时修改
        update_modify: 1,
        // 更新时修改
        comment: '',
        data_dict_id: '',
        association_crud_id: '',
        // 关联表id
        association_field_names: [],
        association_field_names_list: null
      };
      this.fromData.title = "\u65B0\u5EFA\u5B57\u6BB5-".concat(val.label);
      this.fromData.type = '';
      var dynamicList = Commnt.keyValue[val.value];
      setTimeout(function () {
        if (dynamicList) {
          dynamicList.forEach(function (item) {
            if (item.sign == 'dict') {
              item.options = _this8.dictList;
            }
          });
        } else {
          dynamicList = [];
        }
      }, 300);
      this.formConfig = [];
      // 深拷贝是为了不修改原数组
      var config = JSON.parse(JSON.stringify(Commnt.fieldConfig));
      config.splice.apply(config, [2, 0].concat(_toConsumableArray(dynamicList)));
      this.formConfig = config;
      if (['image', 'file'].includes(val.value)) {
        this.formDataInit.max = 1;
        this.formDataInit.size = 5;
      }
      this.$refs.oaDialog.openBox();
    },
    // 新建/编辑字段弹窗回调
    submit: function submit(data) {
      var _this9 = this;
      data.value = this.rowData.value;
      data.crud_id = this.infoData.id;
      var oldData = {};
      var newData = {};
      for (var key in data) {
        if (this.valueItem.includes(key)) {
          oldData[key] = data[key];
        } else {
          newData[key] = data[key];
        }
      }
      var submitData = oldData;
      submitData.options = newData;
      if (this.type == 'edit') {
        dataFieldUpdateApi(this.rowId, submitData).then(function (res) {
          if (res.status == 200) {
            _this9.$refs.oaDialog.handleClose();
            _this9.getList();
          }
        }).catch(function (err) {
          _this9.$message.error(err.message);
        });
      } else {
        dataFieldSaveApi(submitData).then(function (res) {
          if (res.status == 200) {
            _this9.$refs.oaDialog.handleClose();
            _this9.getList();
          }
        }).catch(function (err) {
          _this9.$message.error(err.message);
        });
      }
    },
    pageChange: function pageChange(page) {
      this.where.page = page;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.where.limit = val;
      this.getList();
    }
  }
};